import makeStyles from '@mui/styles/makeStyles';

const generalDialogFormStyles = makeStyles(() => ({
    minHeight50: (props: any) => {
        const { minHeight } = props;
        return {
            minHeight
        };
    },
    hiddenForm: {
        display: 'none'
    }
}));

export default generalDialogFormStyles;
